import { Box, Divider, Typography } from '@mui/material'
import { motion } from 'motion/react'
import { ReactComponent as SuccessIcon } from '../../../../images/success.svg'
import { ReactComponent as RejectIcon } from '../../../../images/rejectIcon.svg'
import { getFormatDate } from '../../../../utils/helpers'
import UseTranslation from '../../../../hooks/UseTranslation'
import { cardVariants } from '../../../../utils/animation'

const NotificationsCard = ({
  notification,
  onApprove,
  onReject,
  title,
  icon,
  customAnimation,
}) => {
  const { t } = UseTranslation()

  return (
    <Box
      sx={styles.notificationCard}
      key={notification?.id}
      data-testid="notification-item"
      component={motion.div}
      variants={cardVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      custom={customAnimation}
    >
      <Box sx={styles.notificationIconContainer}>
        { icon && icon}
        <Typography sx={styles.headerTitle}>
          <Typography sx={styles.title} component="span">
            {notification?.preview || notification?.employee?.name}
          </Typography>
          <Typography sx={styles.cardTime} component="span">
            {getFormatDate(title, `${notification?.notify_date || ''} ${notification?.notify_time}`)}
          </Typography>
        </Typography>
      </Box>
      <Typography sx={styles.text}>
        {notification?.details || notification?.description}
      </Typography>
      {onApprove && onReject && (
        <Box sx={styles.cardFooter}>
          <Box sx={styles.approveButton} onClick={() => onApprove(notification)}>
            <SuccessIcon />
            {t?.Approve}
          </Box>
          <Box sx={styles.rejectButton} onClick={() => onReject(notification)}>
            <RejectIcon />
            {t?.Reject}
          </Box>
        </Box>
      )}
      <Divider sx={styles.divider} />
    </Box>
  )
}

const styles = {
  headerTitle: {
    fontSize: { xs: '13px', sm: '14px' },
    fontWeight: 600,
    display: 'flex',
    alignItems: 'baseline',
    gap: { xs: '10px', sm: '20px' },
    width: '100%',
    maxWidth: { xs: '250px', sm: '415px' },
  },
  text: {
    fontSize: { xs: '13px', sm: '14px' },
    fontWeight: '500',
    color: '#92929D',
    paddingBottom: '9px',
    margin: { xs: '-15px 0px 0px 42px', sm: '-15px 0px 0px 57px' },
  },
  cardFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    '& svg': {
      height: '20px',
      width: '20px',
    },
  },
  divider: {
    width: { xs: '75%', sm: '70%' },
    margin: { xs: '10px 0px 0px 40px', sm: '10px 0px 0px 75px' },
  },
  cardTime: {
    fontSize: '12px',
    color: '#92929D',
    display: 'block',
    marginTop: '4px',
    fontWeight: 400,
    minWidth: 'fit-content',
  },
  notificationCard: {
    display: 'flex',
    padding: '10px 0',
    flexDirection: 'column',
  },
  notificationIconContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    '& svg': {
      borderRadius: '10px',
      backgroundColor: '#EAFAF3',
      height: { xs: '17px', sm: '25px' },
      width: { xs: '17px', sm: '25px' },
      padding: { xs: '7px', sm: '10px' },
      fill: '#29CC8B',

    },
  },
  approveButton: {
    display: 'flex',
    alignItems: { xs: 'flex-start', sm: 'center' },
    cursor: 'pointer',
    mt: '3px',
    color: '#29CC8B',
    gap: '5px',
    fontSize: '13px',
  },
  rejectButton: {
    display: 'flex',
    alignItems: { xs: 'flex-start', sm: 'center' },
    cursor: 'pointer',
    mt: '3px',
    color: '#FC5A5A',
    gap: '5px',
    fontSize: '13px',
  },
  title: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}

export default NotificationsCard
